import { getDownloadURL, ref } from 'firebase/storage';
import { firebase_storage } from '../firebase.config';

export async function getStorage(fileName: string) {
  return getDownloadURL(ref(firebase_storage, fileName));
}
